import state from './purlState'
import mutations from './purlMutations'
import getters from './purlGetters'
import actions from './purlActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
